"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMainPartnerCaptionProperty = exports.mainPartnerCaptionPropertyDefinition = void 0;
exports.mainPartnerCaptionPropertyDefinition = {
    name: 'main-partner-caption',
    type: 'text',
    constraints: [
        {
            name: 'maxLength',
            argument: 90,
        },
    ],
    multiple: false,
    view: { label: 'Main Partner Caption' },
};
const isMainPartnerCaptionProperty = (prop) => {
    return prop.name === exports.mainPartnerCaptionPropertyDefinition.name;
};
exports.isMainPartnerCaptionProperty = isMainPartnerCaptionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFpbi1wYXJ0bmVyLWNhcHRpb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9tYWluLXBhcnRuZXItY2FwdGlvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLG9DQUFvQyxHQUFHO0lBQ2xELElBQUksRUFBRSxzQkFBc0I7SUFDNUIsSUFBSSxFQUFFLE1BQU07SUFDWixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLHNCQUFzQixFQUFFO0NBQ1IsQ0FBQTtBQUkxQixNQUFNLDRCQUE0QixHQUFHLENBQUMsSUFBa0IsRUFBc0MsRUFBRTtJQUNyRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNENBQW9DLENBQUMsSUFBSSxDQUFBO0FBQ2hFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNEJBQTRCLGdDQUV4QyJ9